// P1 scroll-reveal: fades/rises elements tagged with class "p1-reveal" into view.
// Safe no-op if no such elements exist on the page yet.
(function () {
  if (!('IntersectionObserver' in window)) return;

  var targets = document.querySelectorAll('.p1-reveal');
  if (!targets.length) return;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('p1-in');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  targets.forEach(function (el) {
    io.observe(el);
  });
})();
